module.exports = __webpack_public_path__ + "img/novo-financiamento.8371c6ba.jpg";